import React from 'react';
import {InnerHtml} from "./InnerHtml";
import {useAppSettings} from "./hooks/useAppSettings";

const Maintenance = () => {
    const {data: generalData} = useAppSettings({
        page: "general"
    });
    return (
        <div style={{width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <InnerHtml html={generalData["maintainencemessage"]}/>
        </div>);
};

export default Maintenance;
